import * as React from 'react';
import { css } from '@emotion/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../globalStyle/colors';
import { FLEX_CENTERED, FLEX_COLUMN } from './flexBox';


const styles = {
  root: css`
    width: 70px;
    height: 70px;
    border-radius: 100%;
    color: ${COLORS.WHITE};
    background-color: ${COLORS.GREEN};
    font-size: 25px;
    text-align: center;
    flex-shrink: 0;
  `,
  icon: css`
    margin-top: -3px; // Exactly centered looks weird, like there's more space on top (even though there isn't) 
  `,
};


interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  icon: IconDefinition;
}


/**
 * CircleImg: a component that renders a font awesome image in a circle
 *
 * PureComponent: true
 * Redux Connected: false
 */
const CircleImg: React.FC<Props> = props => {
  const { icon, ...rest } = props;

  return (
    <div css={[FLEX_COLUMN, FLEX_CENTERED, styles.root]} {...rest}>
      <FontAwesomeIcon icon={props.icon} css={styles.icon} />
    </div>
  );
};

export default CircleImg;
